import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
//import { AngularFireAuth } from '@angular/fire/auth';
import { AbsAuthService, AuthApiService } from '../shared/services/auth.svc';
import { CookieService } from 'ngx-cookie-service';
//import { AntEnvService } from '../_services/ant.env.svc';

let svcAuthFactory = (http: HttpClient, cookieService:CookieService) =>{
    //console.log(environment.apiType);
    if(environment.apiType == 'FB'){
        //return new AuthService(firebaseAuth);
    }
    else if(environment.apiType == 'API'){
        return new AuthApiService(http, cookieService);
    }
};

export let DataServiceProvider = { 
    provide: AbsAuthService,
    useFactory: svcAuthFactory,
    //deps: [AppService]
};
